
  <button
    class="btn-container"
    (click)="playOrPause()"

  ><span class="play-text">Play Audio</span><span class="btn-audio"
                                                  [ngClass]="isPlay ? 'bi bi-pause-fill': 'bi bi-play-fill'"></span>
  </button>
  <audio #audio [src]="getAudioUrl()"></audio>

